import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RingSize, setRequired } from '../core';


const calibValue_min = 1;
const calibValue_max = 350;


export class ImageCalibrationControl implements IImageCalibrationControl {
	calibrationTool = new FormControl<'line' | 'circle' | 'rings' | null>(null, [Validators.required]);
	calibrationValue = new FormControl<number | null>(null, [Validators.required, Validators.min(calibValue_min), Validators.max(calibValue_max)]);
	proximalRing = new FormControl<RingSize | null>(null);
	distalRing = new FormControl<RingSize | null>(null);
}

export function setImgCalibValidators(form: FormGroup<ImageCalibrationControl>): void {
	form.controls.calibrationTool.valueChanges.subscribe((tool) => {
		setRequired(form.controls.proximalRing, tool === 'rings');
		setRequired(form.controls.distalRing, tool === 'rings');
	});
}

export const imgCalibErrorMsgs: { [key in keyof ImageCalibrationForm]: { [y: string]: string[] } | null } = {
	calibrationTool: {
		[`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_CALIBRATION_TOOL']
	},
	calibrationValue: {
		[`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_CALIBRATION_VALUE'],
		[`${Validators.min.name}`]: ['VALIDATION_MESSAGE_RANGE_CALIBRATION_VALUE', calibValue_min.toString(), calibValue_max.toString()],
		[`${Validators.max.name}`]: ['VALIDATION_MESSAGE_RANGE_CALIBRATION_VALUE', calibValue_min.toString(), calibValue_max.toString()],
	},
	proximalRing: {
		[`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_RING_PROX']
	},
	distalRing: {
		[`${Validators.required.name}`]: ['VALIDATION_MESSAGE_REQUIRED_RING_DIST']
	}
}

export interface IImageCalibrationControl {
	calibrationTool: FormControl<'line' | 'circle' | 'rings' | null>;
	calibrationValue: FormControl<number | null>;
	proximalRing: FormControl<RingSize | null>;
	distalRing: FormControl<RingSize | null>;
}

export interface ImageCalibrationForm {
	calibrationTool: 'line' | 'circle' | 'rings';
	calibrationValue: number;
	proximalRing?: RingSize;
	distalRing?: RingSize;
}
